import React, { forwardRef } from "react";
import { TextField } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import PhoneInput from "react-phone-number-input";
import es from "react-phone-number-input/locale/es.json";
import flags from "react-phone-number-input/flags";
import "react-phone-number-input/style.css";

const useStyles = makeStyles()(theme => ({
    wrap: {
        width: "100%",
        position: "relative",

        "& .PhoneInputCountry": {
            position: "absolute",
            left: 11,
            top: "calc(50% + 4px)",
            transform: "translateY(-50%)",
            zIndex: 1,
            margin: 0,
            display: "flex",
            alignItems: "center",
            gap: 4,
        },
        "& .PhoneInputCountryIcon": {
            boxShadow: "none",
            width: 26,
            height: 19,
            borderRadius: 3,
            outline: `1px solid ${theme.palette.mode === "light" ? "rgba(0,0,0,.12)" : "rgba(255,255,255,.16)"}`,
            outlineOffset: -1,
        },
        "& .PhoneInputCountrySelectArrow": { display: "none" },
        "& .PhoneInputCountrySelect": { cursor: "pointer" },

        "& .PhoneInputInput input": { paddingLeft: "48px !important" },
        "& input": { paddingLeft: "48px !important" },
    },
}));

const MuiInput = forwardRef(({ label, error, helperText, ...props }, ref) => (
    <TextField
        {...props}
        inputRef={ref}
        label={label}
        error={error}
        helperText={helperText}
        variant="outlined"
        margin="dense"
        fullWidth
    />
));

const PhoneField = ({ value, onChange, label, error, helperText }) => {
    const { classes } = useStyles();

    return (
        <div className={classes.wrap}>
            <PhoneInput
                international
                defaultCountry="EC"
                labels={es}
                flags={flags}
                value={value ? `+${String(value).replace(/\D/g, "")}` : ""}
                onChange={(v) => onChange(String(v || "").replace(/\D/g, ""))}
                inputComponent={MuiInput}
                numberInputProps={{ label, error, helperText }}
            />
        </div>
    );
};

export default PhoneField;
